// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* black 
blue 
cyan b5f0f2 */


[data-bs-theme="white-dark"] {
    --bs-nav-link-color: #fff;
    --bs-nav-link-hover-color: #fff;
}

:root {
    --syn-antracit: #383e42 !important;
    --syn-blue: #5eb8ef !important;
    --syn-cyan2: #A5E6F1 !important;
    --syn-cyan: #b5f0f2 !important;
    --syn-light-pink: rgb(255, 242, 242) !important;
}

.pointer-not-allowed {
    cursor: not-allowed;
}

.h7 {}

.bg-antracit {
    background-color: var(--syn-antracit) !important;
}

.bg-cyan {
    background-color: var(--syn-cyan) !important;
}

.bg-light-pink {
    background-color: var(--syn-light-pink) !important;
}

.bg-light-grey {
    background-color: var(--bs-gray-100) !important;
}

.borders {
    border-left: 1px solid var(--syn-antracit);
    border-right: 1px solid var(--syn-antracit);
    border-bottom: 1px solid var(--syn-antracit);
}

td.reporting-entry {
    font-size: 12px;
}

td.reporting-entry:hover {
    background-color: var(--syn-cyan) !important;
}

table.table tfoot {
    border-top: 3px solid var(--bs-border-color);
}

table.table thead {
    border-bottom: 3px solid var(--bs-border-color);
}

table.table td.border-right,
table.table th.border-right {
    border-right: 3px solid var(--bs-border-color);
}

th.today {
    border-top: 2px solid rgb(15, 222, 15);
    border-left: 2px solid rgb(15, 222, 15);
    border-right: 2px solid rgb(15, 222, 15);
}

td.today {
    border-left: 2px solid rgb(15, 222, 15);
    border-right: 2px solid rgb(15, 222, 15);
}

tfoot td.today {
    border-bottom: 2px solid rgb(15, 222, 15);
    border-left: 2px solid rgb(15, 222, 15);
    border-right: 2px solid rgb(15, 222, 15);
}

th.day {
    position: relative;
}

th div.day-name {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    font-size: 10px;
    font-weight: normal;
    background-color: #EEE;
    border-bottom: 1px solid #ccc;
}

th div.day-number {
    position: relative;
    top: 7px;
}

.react-datepicker__triangle__arrow {
    position: absolute;
    pointer-events: none;
    bottom: 100%;
    transform: rotate(180deg) translateY(-1px);
    left: 112px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;aAEa;;;AAGb;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,KAAK;;AAEL;IACI,gDAAgD;AACpD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,0CAA0C;IAC1C,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,sCAAsC;IACtC,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,0CAA0C;IAC1C,WAAW;AACf","sourcesContent":["/* black \nblue \ncyan b5f0f2 */\n\n\n[data-bs-theme=\"white-dark\"] {\n    --bs-nav-link-color: #fff;\n    --bs-nav-link-hover-color: #fff;\n}\n\n:root {\n    --syn-antracit: #383e42 !important;\n    --syn-blue: #5eb8ef !important;\n    --syn-cyan2: #A5E6F1 !important;\n    --syn-cyan: #b5f0f2 !important;\n    --syn-light-pink: rgb(255, 242, 242) !important;\n}\n\n.pointer-not-allowed {\n    cursor: not-allowed;\n}\n\n.h7 {}\n\n.bg-antracit {\n    background-color: var(--syn-antracit) !important;\n}\n\n.bg-cyan {\n    background-color: var(--syn-cyan) !important;\n}\n\n.bg-light-pink {\n    background-color: var(--syn-light-pink) !important;\n}\n\n.bg-light-grey {\n    background-color: var(--bs-gray-100) !important;\n}\n\n.borders {\n    border-left: 1px solid var(--syn-antracit);\n    border-right: 1px solid var(--syn-antracit);\n    border-bottom: 1px solid var(--syn-antracit);\n}\n\ntd.reporting-entry {\n    font-size: 12px;\n}\n\ntd.reporting-entry:hover {\n    background-color: var(--syn-cyan) !important;\n}\n\ntable.table tfoot {\n    border-top: 3px solid var(--bs-border-color);\n}\n\ntable.table thead {\n    border-bottom: 3px solid var(--bs-border-color);\n}\n\ntable.table td.border-right,\ntable.table th.border-right {\n    border-right: 3px solid var(--bs-border-color);\n}\n\nth.today {\n    border-top: 2px solid rgb(15, 222, 15);\n    border-left: 2px solid rgb(15, 222, 15);\n    border-right: 2px solid rgb(15, 222, 15);\n}\n\ntd.today {\n    border-left: 2px solid rgb(15, 222, 15);\n    border-right: 2px solid rgb(15, 222, 15);\n}\n\ntfoot td.today {\n    border-bottom: 2px solid rgb(15, 222, 15);\n    border-left: 2px solid rgb(15, 222, 15);\n    border-right: 2px solid rgb(15, 222, 15);\n}\n\nth.day {\n    position: relative;\n}\n\nth div.day-name {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    font-size: 10px;\n    font-weight: normal;\n    background-color: #EEE;\n    border-bottom: 1px solid #ccc;\n}\n\nth div.day-number {\n    position: relative;\n    top: 7px;\n}\n\n.react-datepicker__triangle__arrow {\n    position: absolute;\n    pointer-events: none;\n    bottom: 100%;\n    transform: rotate(180deg) translateY(-1px);\n    left: 112px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
